import { ViewChild } from '@angular/core';
import { AfterViewInit, Component, EventEmitter, OnInit, Output, ElementRef } from '@angular/core';
import { GlobalSearchHistoryService } from '../../global-search-history.service';
import { faHistory } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-global-quick-search',
  templateUrl: './global-quick-search.component.html',
  styleUrls: ['./global-quick-search.component.css']
})
export class GlobalQuickSearchComponent implements OnInit {
  @ViewChild('searchInput') private inputElement: ElementRef;
  searchQuery: string;
  @Output() search = new EventEmitter<string | number>();
  displayError = false;
  cachedSearches: string[] = [];
  showCachedSearches: boolean = false;
  faHistory = faHistory;
  private isInputFocused = false;
  private blurTimeout: ReturnType<typeof setTimeout> | null = null;

  constructor(
    private el: ElementRef,
    private globalSearchHistoryService: GlobalSearchHistoryService
  ) {}

  ngOnInit(): void {
    this.loadCachedSearches();
  }

  loadCachedSearches(): void {
    this.cachedSearches = this.globalSearchHistoryService.getHistory();
  }

  // Recent searches only open while the input has focus and is empty
  private updateCachedSearchesVisibility(): void {
    this.showCachedSearches = this.isInputFocused && !this.searchQuery && this.cachedSearches.length > 0;
  }

  searchBtn() {
    this.displayError = this.searchQuery?this.searchQuery.length < 3:false;
    if (!this.displayError && this.searchQuery && this.searchQuery.length >= 3) {
      // Save to history
      this.globalSearchHistoryService.addToHistory(this.searchQuery);
      this.loadCachedSearches();
      this.showCachedSearches = false;
    }
    this.search.emit(this.searchQuery);
  }

  handleKeyDown(event: any) {
    if (event.event.key === 'Enter') {
      this.searchBtn();
    } else if (event.event.key === 'Escape') {
      this.showCachedSearches = false;
    }
  }

  onInputFocus(): void {
    if (this.blurTimeout) {
      clearTimeout(this.blurTimeout);
      this.blurTimeout = null;
    }
    this.isInputFocused = true;
    this.updateCachedSearchesVisibility();
  }

  onInputBlur(): void {
    this.isInputFocused = false;
    // Delay hiding to allow click on cached search item
    this.blurTimeout = setTimeout(() => {
      this.blurTimeout = null;
      this.showCachedSearches = false;
    }, 200);
  }

  selectCachedSearch(cachedSearch: string): void {
    this.searchQuery = cachedSearch;
    this.showCachedSearches = false;
    this.searchBtn();
  }

  onValueChanged(event: any): void {
    this.searchQuery = event.value || '';
    // Hide cached searches when user starts typing; show them again once cleared (if focused)
    this.updateCachedSearchesVisibility();
  }

  resetSearch(): void {
    this.searchQuery = '';
    this.displayError = false;
    this.showCachedSearches = false;
    // Emit empty string to reset the parent component state
    this.search.emit('');
  }
}

